import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { IoRefreshOutline } from '../../node_modules/react-icons/io5/index.esm.js';
import Kraken from '../Kraken/index.js';
import Button from '../Button/index.js';
import QuickActionButton from '../QuickActionButton/index.js';
import { genericMemo } from '../../utils/index.js';
import PendingMessage from '../PendingMessage/index.js';
import styles from './styles.css.js';

var _IoRefreshOutline, _IoRefreshOutline2;

function Message(props) {
  const {
    className,
    pending,
    empty,
    filtered,
    errored,
    icon: iconFromProps,
    emptyIcon,
    filteredEmptyIcon,
    erroredEmptyIcon,
    message: messageFromProps,
    pendingMessage,
    emptyMessage = 'No data available',
    filteredEmptyMessage = 'No matching data',
    erroredEmptyMessage = 'Oops! We ran into an issue',
    pendingContainerClassName,
    compact,
    compactPendingMessage,
    compactEmptyMessage,
    compactAndVertical,
    messageHidden = false,
    messageIconHidden = false,
    onReload,
    actions,
    actionsContainerClassName
  } = props;

  if (pending) {
    return /*#__PURE__*/React.createElement(PendingMessage, {
      className: pendingContainerClassName,
      message: pendingMessage,
      compact: compactPendingMessage || compact
    });
  }

  let icon = iconFromProps;
  let message = messageFromProps;

  if (empty || errored) {
    let size = 'medium';

    if (compact) {
      size = 'extraSmall';
    } else if (compactAndVertical) {
      size = 'small';
    }

    if (errored) {
      icon = erroredEmptyIcon ?? /*#__PURE__*/React.createElement(Kraken, {
        variant: "fat",
        size: size
      });
      message = erroredEmptyMessage;
    } else if (filtered) {
      icon = filteredEmptyIcon ?? /*#__PURE__*/React.createElement(Kraken, {
        variant: "search",
        size: size
      });
      message = filteredEmptyMessage;
    } else {
      icon = emptyIcon ?? /*#__PURE__*/React.createElement(Kraken, {
        variant: "ballon",
        size: size
      });
      message = emptyMessage;
    }
  }

  if (!icon && !message) {
    return null;
  }

  const showActions = errored && onReload || actions;
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(className, styles.message, (compactAndVertical || compact || compactEmptyMessage) && styles.compact, compactAndVertical && styles.vertical)
  }, !messageIconHidden && /*#__PURE__*/React.createElement("div", {
    className: styles.iconContainer
  }, icon), !messageHidden && /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, message), showActions && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.actions, actionsContainerClassName)
  }, onReload && compact && /*#__PURE__*/React.createElement(QuickActionButton, {
    name: undefined,
    onClick: onReload,
    variant: "secondary"
  }, _IoRefreshOutline || (_IoRefreshOutline = /*#__PURE__*/React.createElement(IoRefreshOutline, null))), onReload && !compact && /*#__PURE__*/React.createElement(Button, {
    name: undefined,
    onClick: onReload,
    variant: "secondary",
    icons: _IoRefreshOutline2 || (_IoRefreshOutline2 = /*#__PURE__*/React.createElement(IoRefreshOutline, null))
  }, "Reload"), actions));
}

var Message$1 = genericMemo(Message);

export { Message$1 as default };
//# sourceMappingURL=index.js.map
